import Vue from "vue";
Vue.config.devtools = true;

import App from "./App.vue";
import router from "./router";
import {store} from "./store/store";
import {ability} from "./store/ability"
import {abilitiesPlugin} from '@casl/vue'
import Vuetify from "vuetify/dist/vuetify.min.js";
import "vuetify/dist/vuetify.min.css";
import VModal from "vue-js-modal";

import "../node_modules/ag-grid-community/dist/styles/ag-grid.css";
import "../node_modules/ag-grid-community/dist/styles/ag-theme-balham.css";
import AsyncComputed from 'vue-async-computed';

import "./assets/metro-4.2.26-704-5bd053de31245";
import "./assets/metro-4.2.26-704-5bd053de31245.css";

import {ProxyObserver} from "./utils/ProxyObserver";

Vue.use(Vuetify);
Vue.use(VModal, {
  dialog: true,
  dynamic: true
});
Vue.use(AsyncComputed);
Vue.use(abilitiesPlugin, ability);

window.vm = new Vue({
  el: "#app",
  data: {
    instance: {},
    projection: "EPSG:2180"
  },
  router, //router: router,
  store,
  render: h => h(App),
  computed: {
    activeModals() {
      return this.$store.getters.getModalsList;
    },
  },
  created() {
    this.Observer = Object.getPrototypeOf(this.instance.__ob__).constructor;
  },
  methods: {
    createProxy(data) {
      return new ProxyObserver({
        data,
        observer: this.Observer
      });
    },
    generateID() {
      const id = this.$store.getters.getGenerateID;
      this.$store.commit("incrementGenerateID");
      return id;
    },
    resetAllModeals() { //do testów czyszczenie otwartych modali po przebudowaniu aplikacji
      this.activeModals.forEach((modalName) => {
        this.$store.commit("removeModal", modalName);
        this.$modal.hide(modalName);
      });
    }
  }
});



// WEBPACK FOOTER //
// ./src/main.js